angular.module('rjmNg.directives').directive "timeRange", [
  "app"
  "timeRangeEnums"
  "dateService"
  "namedDates"
  "$timeout"
  (app, timeRangeEnums, dateService, namedDates, $timeout) ->
    restrict: "E"
    templateUrl: "directive.timeRange.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      inputTimeRange: "="
      outputTimeRange: "="
      isGaMetric: "=?"
      valid: "="
      changed: "="
      timeFilterView: "=?"
      showDefault: "=?"
      movingTimeRangePresets: "=?"
      hiddenMovingUnits: "=?"
    controller: [
      "$scope"
      (
        $scope
      ) ->
        view = @

        DATE_DISPLAY_FORMAT = 'MMM Do, YYYY'
        DATE_STATIC_TIME_RANGE_FORMAT = "YYYY-MM-DD"
        RJQL_VERSION = app.getRjqlVersion()
        view.DATE_NAMES = namedDates
        view.movingTimeRangeUnits = angular.copy(timeRangeEnums.MOVING_TIME_RANGE_UNITS)
        view.MOVING_TIME_RANGE_DIRECTIONS = timeRangeEnums.MOVING_TIME_RANGE_DIRECTIONS
        TIME_RANGE_TYPES = timeRangeEnums.TIME_RANGE_TYPES
        view.MOVING_TIME_RANGE_TYPES = timeRangeEnums.MOVING_TIME_RANGE_TYPES
        view.MOVING_TIME_RANGE_TYPES_NAMES = timeRangeEnums.MOVING_TIME_RANGE_TYPES_NAMES
        DEFAULT_MOVING_TIME_RANGE_TYPE = view.MOVING_TIME_RANGE_TYPES.LAST_YEAR
        view.outputTimeRange = undefined
        view.movingTimeRangeType = null

        _getLocalRangeFromType = (type) ->
          tempRange = dateService.getMovingTimeRangeFromType(type, RJQL_VERSION)
          return dateService.translateToLocalRange(tempRange, RJQL_VERSION)

        _setMovingTimeRangeType = () ->
          view.movingTimeRangeType = dateService.getTypeFromMovingTimeRange(view.localTimeRange)

        _getDefaultLocalRange = () ->
          return if view.showDefault then null else _getLocalRangeFromType(DEFAULT_MOVING_TIME_RANGE_TYPE)

        view.validateRange = () ->
          if view.localTimeRange
            view.changed = not dateService.compareRangeToLocalRange(view.inputTimeRange, view.localTimeRange, RJQL_VERSION)
            tempRjqlRange = dateService.translateToRJQLRange(view.localTimeRange, RJQL_VERSION)
            view.timeRangeString = dateService.getRangeString(tempRjqlRange, DATE_DISPLAY_FORMAT, true)
            specificRangeValid = dateService.staticLocalRangeIsValid(view.localTimeRange)
            movingRangeValid = dateService.movingRangeIsValid(tempRjqlRange)
            view.valid = specificRangeValid and movingRangeValid
            if view.valid
              switch view.localTimeRange.type
                when TIME_RANGE_TYPES.STATIC
                  view.outputTimeRange = dateService.getStaticTimeRange(view.localTimeRange.start.datetime, view.localTimeRange.end.datetime, RJQL_VERSION)
                when TIME_RANGE_TYPES.MOVING
                  view.outputTimeRange = tempRjqlRange
          else
            view.changed = if view.inputTimeRange? then true else false
            view.valid = if view.showDefault then true else false
            view.timeRangeString = ["Default Report Start", "Default Report End"]
            view.outputTimeRange = null

        view.setStaticTimeRange = (allTime = true) ->
          if allTime
            datetimes = [view.DATE_NAMES.OLDEST, view.DATE_NAMES.NOW]
          else
            # Use current dates from moving time range
            tempRange1 = dateService.translateToRJQLRange(view.localTimeRange, RJQL_VERSION)
            datetimes = dateService.getRangeString(tempRange1, DATE_STATIC_TIME_RANGE_FORMAT, true)

          tempRange2 = dateService.getStaticTimeRange(datetimes[0], datetimes[1], RJQL_VERSION)
          view.localTimeRange = dateService.translateToLocalRange(tempRange2, RJQL_VERSION)

          view.movingTimeRangeType = null
          view.validateRange()

        view.setMovingTimeRangeFromType = (type) ->
          # in case of choosing not Custom range just show custom range editor with this range
          if type isnt view.MOVING_TIME_RANGE_TYPES.CUSTOM
            view.localTimeRange = _getLocalRangeFromType(type)
            view.movingTimeRangeType = type
            view.validateRange()
          # in case of choosing the Custom range
          else
            # check what range was chosen before
            switch view.movingTimeRangeType
              # if it was All-Time or null range then use default range in the custom range editor
              when view.MOVING_TIME_RANGE_TYPES.ALL_TIME, null
                view.setDefaultMovingTimeRange()
                view.movingTimeRangeType = type
              # if it was Custom then have to close custom range editor and show
              # the range that was set before or default range (in the case custom range was before too)
              when view.MOVING_TIME_RANGE_TYPES.CUSTOM
                view.setMovingTimeRangeDependingOnInputRange()
                if view.movingTimeRangeType is view.MOVING_TIME_RANGE_TYPES.CUSTOM
                  view.setDefaultMovingTimeRange()
              # for any other types just show custom range editor with this range
              else
                view.movingTimeRangeType = type

        view.oldestDateClicked = () ->
          view.localTimeRange.start.datetime = view.DATE_NAMES.OLDEST

        view.newestDateClicked = () ->
          view.localTimeRange.end.datetime = view.DATE_NAMES.NOW

        view.setDefaultMovingTimeRange = () ->
          view.localTimeRange = _getLocalRangeFromType(DEFAULT_MOVING_TIME_RANGE_TYPE)
          _setMovingTimeRangeType()
          view.validateRange()

        view.setStaticTimeRangeDependingOnInputRange = () ->
          if view.inputTimeRange? and dateService.isRangeStatic(view.inputTimeRange)
              view.localTimeRange = dateService.translateToLocalRange(view.inputTimeRange, RJQL_VERSION)
              view.movingTimeRangeType = null
              view.validateRange()
          else
            if !view.isGaMetric
              view.setStaticTimeRange(allTime = true)
            else
              view.setStaticTimeRange(allTime = false)

        view.setMovingTimeRangeDependingOnInputRange = () ->
          if view.inputTimeRange? and dateService.isRangeMoving(view.inputTimeRange)
            view.localTimeRange = dateService.translateToLocalRange(view.inputTimeRange, RJQL_VERSION)
          else if view.inputTimeRange? and
            dateService.isRangeStatic(view.inputTimeRange) and
            dateService.isStaticRangeAllTime(view.inputTimeRange)
              view.setMovingTimeRangeFromType(view.MOVING_TIME_RANGE_TYPES.ALL_TIME)
              return
          else
            view.localTimeRange = _getDefaultLocalRange()
          _setMovingTimeRangeType()
          view.validateRange()

        view.restoreDefaults = () ->
          view.localTimeRange = null
          view.movingTimeRangeType = null
          view.validateRange()

        view.initialize = () ->
          view.localTimeRange = if view.inputTimeRange? then dateService.translateToLocalRange(view.inputTimeRange, RJQL_VERSION) else _getDefaultLocalRange()
          _setMovingTimeRangeType()
          view.validateRange()

        view.initializeAfterDelay = () ->
          # Function initialize have to run with delay, because of view.inputTimeRange
          $timeout(() -> view.initialize())

        view.$onInit = () ->
          view.hiddenMovingUnits ?= []
          view.isGaMetric ?= false
          view.timeFilterView = !!view.timeFilterView
          view.showDefault = !!view.showDefault

          view.movingTimeRangePresets ?= [
            [
              "YESTERDAY"
              "LAST_WEEK"
              "LAST_MONTH"
              "LAST_QUARTER"
              "LAST_YEAR"
            ]
          ,
            [
              "TODAY"
              "THIS_WEEK"
              "THIS_MONTH"
              "THIS_QUARTER"
              "THIS_YEAR"
            ]
          ]
          if view.hiddenMovingUnits.length > 0
            for unit in view.hiddenMovingUnits
              delete view.movingTimeRangeUnits[unit]
          view.initialize()

        view
    ]
    link: (scope, element, attr, view) ->
      scope.$watch('view.localTimeRange', view.validateRange, true)
      scope.$watch('view.inputTimeRange', view.initialize, true)
      scope.$on("initializeTimeRange", view.initializeAfterDelay)
]
